import { InternalTransportGate, InternalTransportToolVariant } from "../internalTransport.types";
import { getInternalTransportApiHooks } from "../internalTransportApi.config";

interface UseInternalTransportApiOptions {
  gate: InternalTransportGate;
  variant: InternalTransportToolVariant;
  internalTransportId: string | null;
}

export const useInternalTransportApi = ({
  gate,
  variant,
  internalTransportId
}: UseInternalTransportApiOptions) => {
  const { useGetById, usePost, usePut, useDelete, useGetOriginalById } =
    getInternalTransportApiHooks(gate, variant);

  const { data, status, fetchStatus } = useGetById(internalTransportId);
  const { mutate: postInternalTransport, isLoading: postLoading } = usePost();
  const { mutate: putInternalTransport, isLoading: putLoading } = usePut();
  const { mutate: deleteInternalTransport } = useDelete();
  const { data: originalTransportData } = useGetOriginalById(
    variant === "simulate" ? data?.originalId : null
  );

  const isPageLoading =
    Boolean(internalTransportId && status === "loading" && fetchStatus === "fetching") ||
    postLoading ||
    putLoading;

  return {
    data,
    status,
    postInternalTransport,
    putInternalTransport,
    deleteInternalTransport,
    originalTransportData,
    isPageLoading
  };
};
